/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        logoContainer: {
            backgroundColor: 'yellow.400',
            width: '9.375rem',
            height: '5.4375rem',
            display: 'flex',
            justifyContent: 'center',
            paddingTop: '1.5rem'
        },
        logo: {
            width: '7.5rem',
            height: 'auto'
        },
        submitBtn: {
            fontWeight: 'normal',
            fontSize: 'lg',
            lineHeight: 7
        }
    },
    sizes: {},
    parts: ['logoContainer', 'logo', 'submitBtn']
}
